export default __webpack_public_path__ + "static/media/optimizedMazeFlash.f6d23e61.gif";